import CreateTicketModal from './CreateTicketModal';
export default CreateTicketModal;